module.exports = __webpack_public_path__ + "img/shangchuan.a4f3603a.png";